import React from 'react';

import PropTypes from 'prop-types';

import EmptyState from '@adsk/alloy-react-empty-state';
import { useLocale } from '@adsk/alloy-react-locale';

const PhotoGalleryAccessLimitedEmptyState = ({ hideDescription }) => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  return (
    <div
      style={{
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <EmptyState
        illustrationType={EmptyState.ILLUSTRATION_TYPES.PICTURES_GREY}
        title={T.translate('NO_PHOTOS_TO_DISPLAY')}
        description={
          hideDescription
            ? null
            : T.translate('NO_PHOTOS_TO_DISPLAY_DESCRIPTION')
        }
      />
    </div>
  );
};

PhotoGalleryAccessLimitedEmptyState.propTypes = {
  hideDescription: PropTypes.bool,
};

export default PhotoGalleryAccessLimitedEmptyState;
